import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import LanguageStrings from '../../../i18n/locales'
const DashboardStrings = LanguageStrings().Dashboard

export const grandParentBreadcrumbState = {
  honHeading: 'HONEYWELL FORGE PERFORMANCE+ FOR UTILITIES | AMI OPERATIONS HUB',
  assetMgmt: DashboardStrings.Asset_Management
}

export const grandParentBreadcrumbSlice = createSlice({
  name: 'GrandParentBreadcrumbSlice',
  initialState: 'Honeywell Forge Performance+ for Utilities | AMI Operations Hub',
  reducers: {
    changeGrandParentBreadcrumb: (state, action: PayloadAction<string>) => {
      return action.payload
    }
  }
})

export const { changeGrandParentBreadcrumb } = grandParentBreadcrumbSlice.actions
export default grandParentBreadcrumbSlice.reducer
